import api from 'src/api';
import { notice, commandType } from 'src/utils';

const data = {
  consolidatedEvaluation: undefined,
  votesByOperators: [],
  votesByRequestTypes: [],
  votesByChannels: [],
  avgOfSkillsBySelectedOperator: [],
  avgOfRtBySelectedChannel: [],
  avgOfChannelBySelectedRt: [],
  avgResultList: [],
};

function updateConsolidatedEvaluation(commit, votes) {
  commit('CONSOLIDATED_EVALUATION', votes.value);
}

function updateAverageVotesForOperators(commit, votes) {
  commit('AVERAGE_VOTES_FOR_OPERATORS', votes);
}

function updateAverageVotesForChannels(commit, votes) {
  commit('AVERAGE_VOTES_FOR_CHANNELS', votes);
}

function updateAverageVotesForRequestTypes(commit, votes) {
  commit('AVERAGE_VOTES_FOR_REQUEST_TYPES', votes);
}

function convert(votes, key) {
  return votes.map((vote) => ({
    title: vote[key],
    value: typeof vote.avgVote === 'number' ? vote.avgVote : 0,
    id: vote.id || 0,
    identifier: vote.identifier ? vote.identifier : '',
  }));
}

function convertOperator(votes) {
  return votes.map((vote) => ({
    avgVote: vote.avgVote,
    name: vote.name || vote.fullName,
  }));
}

const averageMapValues = {
  scoreByOperators: api.getAvgIndicativeVotesForOperator,
  scoreByChannels: api.getAvgVoteByOperatorForChannel,
  scoreByRequestTypes: api.getAvgVoteByOperatorForRequestType,
};

const actions = {
  getAverageVotes({ rootState }) {
    if (notice !== undefined) {
      notice.push(rootState.home.currentTeam, commandType.AVERAGE_VOTES, {});
    }
  },
  getAverageList({ commit }, avg) {
    commit('AVG_VOTES_CLEAR');
    averageMapValues[avg.key](avg.value).then((val) => (commit('AVG_VOTES_LIST', val)));
  },
  async getAvgIndicativeVotesForChannel({ commit }, channelType) {
    try {
      const votes = await api.getAvgIndicativeVotesForChannel(channelType);
      commit('AVG_OF_RT_BY_SELECTED_CHANNEL', votes);
    } catch (error) {
      console.error('Ошибка при получении данных:', error); // TODO нужно добавить общюю обработку ошибок
    }
  },
  async getAvgIndicativeVotesForRequestType({ commit }, requestTypeId) {
    const votes = await api.getAvgIndicativeVotesForRequestType(requestTypeId);
    commit('AVG_OF_CHANNELS_BY_SELECTED_RT', votes);
  },
  updateResults({ commit }, event) {
    switch (event.type) {
      case commandType.CONSOLIDATED_EVALUATION:
        updateConsolidatedEvaluation(commit, event.data);
        break;
      case commandType.AVERAGE_VOTES_FOR_OPERATORS:
        updateAverageVotesForOperators(commit, event.data);
        break;
      case commandType.AVERAGE_VOTES_FOR_CHANNELS:
        updateAverageVotesForChannels(commit, event.data);
        break;
      case commandType.AVERAGE_VOTES_FOR_REQUEST_TYPES:
        updateAverageVotesForRequestTypes(commit, event.data);
        break;
      default:
        break;
    }
  },
};

const mutations = {
  CONSOLIDATED_EVALUATION(state, value) {
    state.consolidatedEvaluation = value;
  },
  AVERAGE_VOTES_FOR_OPERATORS(state, { votes }) {
    state.votesByOperators = convert(votes, 'fullName');
  },
  AVERAGE_VOTES_FOR_CHANNELS(state, { votes }) {
    state.votesByChannels = convert(votes, 'name');
  },
  AVERAGE_VOTES_FOR_REQUEST_TYPES(state, { votes }) {
    state.votesByRequestTypes = convert(votes, 'name');
  },
  AVG_OF_CHANNELS_BY_SELECTED_RT(state, votes) {
    state.avgOfChannelBySelectedRt = votes;
  },
  AVG_OF_RT_BY_SELECTED_CHANNEL(state, votes) {
    state.avgOfRtBySelectedChannel = votes;
  },
  AVG_VOTES_LIST(state, votes) {
    state.avgResultList = convertOperator(votes);
  },
  AVG_VOTES_CLEAR(state) {
    state.avgResultList = [];
  },
};

const store = {
  state: data,
  actions,
  mutations,
  namespaced: true,
};

export default store;
